import React from 'react';
import { Col, Image } from 'react-bootstrap';
import BackIcon from '@/ui/assets/BackIcon';
import CloseIcon from '@/ui/assets/CloseIcon';

interface HeaderMobileUserProps {
    handleIconClick: () => void;
    logoSrc: string;
    iconClass: string;
    logoClass: string;
    iconPosition?: 'left' | 'right';
}

const HeaderMobileUser: React.FC<HeaderMobileUserProps> = ({
    handleIconClick,
    logoSrc,
    iconClass,
    logoClass,
    iconPosition = 'left'
}) => {
    return (
        <Col className='d-flex my-4'>
            {iconPosition === 'left' && (
                <>
                    <Col xs={2} className='d-flex justify-content-start align-items-center px-4'>
                        <BackIcon onClick={handleIconClick} classMain={iconClass} />
                    </Col>
                    <Col xs={8} className='d-flex justify-content-center align-items-center'>
                        <Image src={logoSrc} className={logoClass} />
                    </Col>
                </>
            )}

            {iconPosition === 'right' && (
                <>
                    <Col xs={2}></Col>
                    <Col xs={8} className='d-flex justify-content-center align-items-center'>
                        <Image src={logoSrc} className={logoClass} />
                    </Col>
                    <Col xs={2} className='d-flex justify-content-end align-items-center pe-4'>
                        <CloseIcon onClick={handleIconClick} classMain={iconClass} />
                    </Col>
                </>
            )}

        </Col>
    );
};

export default HeaderMobileUser;